/**
 * Pure formatting utility for entity write tool results.
 * No browser imports — safe to use in both gui and tool-runtime.
 */

export function formatWriteResult(result: any, toolInput: any, entityType: string): any {
  try {
    if (result?.data) {
      const data = result.data;
      return {
        type: 'entity_operation',
        summary: result.message || `${data.operation} completed`,
        data: {
          operation: data.operation,
          nodeCount: data.stats?.nodesModified || 0,
          fullContent: data.messageContext?.fullContent,
          contentPreview: data.messageContext?.contentPreview,
          entityId: toolInput?.entityId,
          affectedNodes: data.affectedNodes,
        },
        meta: {
          duration: result.metadata?.executionTime,
          entityType,
        },
      };
    }

    return {
      type: 'tool_summary',
      summary: result?.message || `Updated ${entityType}`,
      data: result?.data || {},
    };
  } catch (error) {
    console.warn(`[${entityType}_write] Error in formatViewData:`, error);
    return {
      type: 'tool_summary',
      summary: `Updated ${entityType}`,
      data: {},
    };
  }
}
